<ng-container *ngIf="scheduledProceedingId() as proceedingId">
  <div #tabHost class="hearing-phase-tabs" data-testid="hearing-phase-tabs" [attr.data-active-section]="activeSection()">
    <ui-tab-group [tabConfig]="phaseTabs()"></ui-tab-group>
  </div>

  <div
    *ngIf="!sharedTabActive()"
    class="hearing-phase-workspace"
    [attr.data-testid]="'hearing-tab-panel-' + activeSection()"
    [attr.data-section]="activeSection()"
  >
    <ng-container [ngSwitch]="phase()">
      <phms-pre-hearing-capture
        *ngSwitchCase="'pre'"
        [scheduledProceedingId]="proceedingId"
        [workflowManaged]="workflowManaged()"
        [recordOnlyReview]="true"
      ></phms-pre-hearing-capture>

      <phms-suitability-hearing
        *ngSwitchCase="'at'"
        [scheduledProceedingId]="proceedingId"
      ></phms-suitability-hearing>

      <phms-post-hearing-workspace
        *ngSwitchCase="'post'"
        [scheduledProceedingId]="proceedingId"
        [legalReviewId]="legalReviewId()"
      ></phms-post-hearing-workspace>
    </ng-container>
  </div>
</ng-container>
